import { useSnackbar, OptionsObject, SnackbarKey } from "notistack";
import { ReactNode, useCallback } from "react";
import { routeToastToPageAlert } from "./usePageAlert";

type SnackbarMessage = string | ReactNode;

export function useAppSnackbar() {
  const snackbar = useSnackbar();

  const enqueueSnackbar = useCallback(
    (message: SnackbarMessage, options?: OptionsObject): SnackbarKey => {
      const variant = options?.variant;
      if ((variant === "success" || variant === "error") && typeof message === "string") {
        if (routeToastToPageAlert({ type: variant, title: message })) {
          return "";
        }
      }

      return snackbar.enqueueSnackbar(message, options);
    },
    [snackbar]
  );

  return {
    ...snackbar,
    enqueueSnackbar,
  };
}
